<template>
  <carousel-slide :class="[baseCss, `overflow-${overflow}`]" role="tabpanel">
    <div :class="[$parent.paddingOff ? null : $parent.vertical ? ['px-2'] : ['p-2'], 'text-sm']">
      <slot />
    </div>
  </carousel-slide>
</template>
<script>
import methods from '../../mixins/methods'

export default {
  name: 'TabPanel',
  mixins: [
    methods
  ],
  data () {
    return {
      baseCss: this.componentBaseCss('tab-panel', [])
    }
  },
  props: {
    label: {
      type: String
    },
    disabled: {
      type: Boolean
    },
    icon: {
      type: String
    },
    overflow: {
      type: String,
      default: 'auto'
    }
  },
  mounted () {
    this.onMounted()
  },
  methods: {
    onMounted () {
      this.getAllItems()
    },
    getAllItems () {
      this.$parent.$el.querySelectorAll(`.${this.baseCss}`).forEach((item, index) => {
        item.setAttribute('data-tab-panel', index)
        item.setAttribute('data-tab-panel-disabled', this.disabled)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/bcq-ui/components/tab-panel/tab-panel.vue